import { ENCRYPTION_KEY, API_KEY } from "../operations/environment";
import CryptoJS from "crypto-js";

// Console log helper (assuming you have this)
export const consoleLog = (data) => {
  if (process.env.NODE_ENV === 'development') {
    console.log(data);
  }
};

// Encrypt function for objects/data
export function encryptData(data) {
  consoleLog([data, "payload"]);
  const stringifiedData = JSON.stringify(data);
  return CryptoJS.AES.encrypt(stringifiedData, ENCRYPTION_KEY).toString();
}

// Encrypt function for strings (like JWT tokens)
export function encryptString(text) {
  return CryptoJS.AES.encrypt(text, ENCRYPTION_KEY).toString();
}

// Decrypt function - returns the decrypted STRING (NOT parsed JSON)
export function decryptData(encryptedData) {
  try {
    consoleLog([encryptedData, 'encryptedData']);
    const bytes = CryptoJS.AES.decrypt(encryptedData, ENCRYPTION_KEY);
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    consoleLog([decryptedData, 'decryptedData']);

    if (!decryptedData) {
      throw new Error("Decryption failed - empty result");
    }

    return decryptedData;  // Return STRING, not parsed JSON
  } catch (error) {
    console.error("Decryption error:", error);
    throw error;
  }
}

// Decrypt function specifically for JWT tokens (returns string, not parsed)
export function decryptJWT(encryptedToken) {
  try {
    consoleLog([encryptedToken, 'encrypted JWT']);
    const bytes = CryptoJS.AES.decrypt(encryptedToken, ENCRYPTION_KEY);
    const decryptedToken = bytes.toString(CryptoJS.enc.Utf8);
    consoleLog([decryptedToken, 'decrypted JWT']);
    
    if (!decryptedToken) {
      throw new Error("JWT decryption failed - empty result");
    }
    
    return decryptedToken; // Return as string, no JSON.parse
  } catch (error) {
    console.error("JWT decryption error:", error);
    throw error;
  }
}

// Universal decrypt function with safe parsing
export function decryptDataSafe(encryptedData) {
  try {
    consoleLog([encryptedData, 'encryptedData']);
    const bytes = CryptoJS.AES.decrypt(encryptedData, ENCRYPTION_KEY);
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    consoleLog([decryptedData, 'decryptedData']);
    
    if (!decryptedData) {
      throw new Error("Decryption failed - empty result");
    }
    
    // Try to parse as JSON, if it fails return as string
    try {
      return JSON.parse(decryptedData);
    } catch (e) {
      // It's a string (like a JWT), return as-is
      return decryptedData;
    }
  } catch (error) {
    console.error("Decryption error:", error);
    throw error;
  }
}

// Legacy contract used by /app/v1/auth/* routes (adminLogin, generateOTP,
// verify). Auth backend decrypts the JWT WITHOUT a JSON.parse step, so we must
// AES-encrypt the raw JWT string (no JSON.stringify). Keep this as-is.
export function getHeaderConfig(signal, accessJWT) {
  const encryptedToken = accessJWT ? encryptString(accessJWT) : "";

  if (signal) {
    return {
      headers: {
        "Content-Type": "text/plain",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers": "*",
        "x-access-token": encryptedToken,
        "x-api-key": API_KEY,
      },
      signal,
    };
  }
  return {
    headers: {
      "Content-Type": "text/plain",
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers": "*",
      "x-access-token": encryptedToken,
      "x-api-key": API_KEY,
    },
  };
}

// Gateway contract used by /app/v1/beadmin/* routes. The gateway's global JWT
// hook does `JSON.parse(AES.decrypt(x).toString(Utf8))`, so we must
// AES-encrypt JSON.stringify(jwt) on this side. Used by apiClient.js.
//
// Backend-host routing is done via ?env=<env> query param (injected by
// apiClient), not a custom header — the upstream CloudFront allow-headers
// list is fixed and doesn't include any new custom header.
export function getBeAdminHeaderConfig(signal, accessJWT) {
  const encryptedToken = accessJWT ? encryptData(accessJWT) : "";

  if (signal) {
    return {
      headers: {
        "Content-Type": "text/plain",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers": "*",
        "x-access-token": encryptedToken,
        "x-api-key": API_KEY,
      },
      signal,
    };
  }
  return {
    headers: {
      "Content-Type": "text/plain",
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers": "*",
      "x-access-token": encryptedToken,
      "x-api-key": API_KEY,
    },
  };
}